<mat-card class="example-card">
  <mat-card-header class="titreFrm">
    <mat-card-title>{{'Génération de factures'.toUpperCase()}}</mat-card-title>
  </mat-card-header>
  <mat-card-content class="border">
    <mat-card>
      <div class="btn">
        <div class="button-row">
          <button (click)="afficher()" mat-raised-button class="colorGreen"><mat-icon>search</mat-icon>Afficher</button>
      </div>
      <div class="button-row">
        <button (click)="generer()" mat-raised-button class="colorGreen"><mat-icon>settings</mat-icon>Générer</button>
      </div>
      </div>
      <div class="marginRight10">
        <mat-form-field     appearance="outline" >
          <mat-label>Du</mat-label>
          <input matInput [matDatepicker]="dateDebut" placeholder="Du" [(ngModel)]="date_Debut">
          <mat-datepicker-toggle matSuffix [for]="dateDebut"></mat-datepicker-toggle>
          <mat-datepicker #dateDebut></mat-datepicker>
        </mat-form-field>
        <mat-form-field     appearance="outline" >
          <mat-label>Au</mat-label>
          <input matInput [matDatepicker]="dateFin" placeholder="Au" [(ngModel)]="date_Fin">
          <mat-datepicker-toggle matSuffix [for]="dateFin"></mat-datepicker-toggle>
          <mat-datepicker #dateFin></mat-datepicker>
        </mat-form-field>
            
      </div>
      <div *ngIf="showTree" id="treeFacture" class="demo"></div>  
    </mat-card>
    
  </mat-card-content>
</mat-card>